import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationPermissionsHelper } from './helpers/navigation-permissions.helper';
import { NavigationItemInterface } from './interfaces/navigation.interface';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  public selectedKey: string;
  public prevItems: NavigationItemInterface[] = [];
  public navItems: NavigationItemInterface[] = [];
  public level = 0;

  private navigationItemsList: NavigationItemInterface[] = [];

  constructor(
    private readonly navigationPermissionsHelper: NavigationPermissionsHelper,
    private readonly router: Router,
    private readonly location: Location,
  ) {
  }

  ngOnInit(): void {
    this.loadNavigationItemsList();
    this.navItems = this.navigationItemsList;
    this.selectedKey = sessionStorage.getItem('NAVIGATION_KEY') || this.navigationItemsList[0].key;
  }

  public select(selected: NavigationItemInterface): void {
    if (selected && selected.hasChildren) {
      this.level += 1;
      this.navItems = selected.children;
      this.prevItems = this.navigationItemsList;
    } else {
      this.selectedKey = selected.key;
      sessionStorage.setItem('NAVIGATION_KEY', this.selectedKey);
      this.router.navigate([selected.url]);
    }
  }

  public goBack(): void {
    this.level -= 1;
    // hack to support additional nest level
    this.navItems = this.level === 1 ? this.prevItems : this.navigationItemsList;
    this.findItem(true, this.prevItems[0].url, this.navigationItemsList, 0);
  }

  public isItemSelected(item: string): boolean {
    if (this.selectedKey !== item) {
      return false;
    }
    return true;
  }

  private findItem(
    justFindPrev: boolean,
    url: string,
    items: NavigationItemInterface[],
    level,
    prevItems?: NavigationItemInterface[],
  ): NavigationItemInterface[] {
    let item: NavigationItemInterface;
    for (let i = 0; i < items.length; i++) {
      item = items[i];
      if (item.hasChildren) {
        const res = this.findItem(justFindPrev, url, item.children, level + 1, items);
        if (res !== null) {
          return res;
        }
      } else {
        if (this.location.path() === item.url) {
          if (!justFindPrev) {
            this.level = level;
            this.selectedKey = item.key;
          }
          this.prevItems = prevItems || items;
          return items;
        }
      }
    }
    return null;
  }

  private loadNavigationItemsList(): void {
    this.navigationItemsList = this.navigationPermissionsHelper.getNavigationItems();
  }
}
